import { Alert } from '@material-ui/lab';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const StyledText = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

type InfoAlertProps = { children: ReactNode };

export function InfoAlert({ children }: InfoAlertProps) {
  return (
    <Alert severity="info" role="status" aria-live="polite">
      <StyledText>{children}</StyledText>
    </Alert>
  );
}
